import React, { useState, useEffect } from 'react';
import './App.css';
import { Switch, Route, HashRouter, Redirect } from 'react-router-dom';
import AdminContainer from './AdminContainer';
import { AuthContainer } from './auth';
import { NotFoundPage, setupInterceptors } from './shared';
import AuthRoute from './auth/components/AuthRoute/AuthRoute';
import { useWebsitesFacade } from './websites/store/hooks';
import { Spin } from 'antd';
import { useSessionFacade } from './auth/store/hooks';
import { axiosInstance } from './api';

function App() {
  const [isReady, setReady] = useState(false);
  const websitesFacade = useWebsitesFacade();
  const sessionFacade = useSessionFacade();

  /** Here we make first request to get list of websites and check if session is active */
  useEffect(() => {
    const setLoggedOut = () => {
      sessionFacade.setLoggedIn(false);
    };

    const loadWebsites = async () => {
      const res = await websitesFacade.loadAll();

      if (res.response) {
        sessionFacade.setLoggedIn(true);
      }

      setupInterceptors(axiosInstance, setLoggedOut);

      setReady(true);
    };

    loadWebsites();
  }, [sessionFacade, websitesFacade]);

  if (!isReady) {
    return (
      <div className="app-loading-screen">
        <Spin />
      </div>
    );
  }

  return (
    <HashRouter>
      <Switch>
        <Route exact={true} path="/" render={() => <Redirect to="/admin" />} />
        <Route path="/auth" component={AuthContainer} />
        <AuthRoute path="/admin" Component={AdminContainer} />
        <Route path="/404" component={NotFoundPage} />
        <Route render={() => <Redirect to="/404" />} />
      </Switch>
    </HashRouter>
  );
}

export default App;
